<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Clave}}</p></td>                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdTipoLente" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <button @click="AgregarElemento(lista)" v-b-tooltip.hover.left :title="lista.Proceso == 3 || lista.Proceso == 2 ? 'Agregar Articulos' : 'Agregar Sublineas'" class="btn btn-warning btn-icon btn-sm rounded me-2">
                                    <i v-if="lista.Proceso == 3 || lista.Proceso == 2" class="fas fa-box-full"/> <!-- Articulos -->
                                    <i v-else class="fas fa-list-ol"></i> <!-- Sublineas-->
                                </button>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="18"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
		<CModal :pConfigModal="ConfigModalSublinea" :poBtnSave="oBtnSaveSublinea">
			<template slot="Form">
				<!-- <SublineaList :poBtnSave="oBtnSaveSublinea"></SublineaList> -->
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from './Form.vue';
// import SublineaList from '../tipoxsublinea/List.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionTipolente';
const EmitEjecuta2 = 'modalSublinea';

export default {
    name: 'ListaTipolente',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        // SublineaList
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado Tipos lente',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                ShowTitleFirst: false,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModalSublinea:{
                ModalTitle: "Sublíneas",
                ModalNameId: 'ModalFormSub',
                EmitSeccion: EmitEjecuta2,
                ShowFooter: false,
                ModalSize: 'lg',
            },
            oBtnSaveSublinea: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("tiposlentes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('tiposlentes/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        AgregarElemento(item) {
            
            switch (parseInt(item.Proceso)) {
                case 1:
                    sessionStorage.setItem('OrigenList','progressive');
                    this.$router.push({name:'tipolentexsublinea',params:{pObjEnviado:item}});
                    break;
                    
                case 2:
                    sessionStorage.setItem('OrigenMenu','TpLente');
                    sessionStorage.setItem('OrigenList','Lends');
                    this.$router.push({name:'articulosweb',params:{pObjTipoLente:item,pObjSublinea:{IdSublinea: 0}}});
                    break;

                case 3:
                    sessionStorage.setItem('OrigenMenu','TpLente');
                    sessionStorage.setItem('OrigenList','Lends');
                    this.$router.push({name:'articulosweb',params:{pObjTipoLente:item,pObjSublinea:{IdSublinea: 0}}});
                    break;
            
                default:
                    console.error('Proceso no definido')
                    break;
            }
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        sessionStorage.setItem('OrigenMenu','');
        sessionStorage.setItem('OrigenList','');
        sessionStorage.setItem('objTipoLente','');
        sessionStorage.setItem('objSublinea','');
        sessionStorage.setItem('objArticuloweb','');

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn_'+EmitEjecuta);
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn_'+EmitEjecuta,()=>
        {
            this.Regresar();
        });
    }
}
</script>
